import App from "@/components/project-finder";
import type { GetServerSideProps, GetServerSidePropsContext } from "next";
import { wrapper } from "@/redux/store/store";
import { fetchAnonymousUser } from "@/redux/features/anonymous-user/thunk";
import { fetchProjectFinder } from "@/redux/features/project-finder/thunk";
import { fetchProjects } from "@/redux/features/projects/thunk";
import { fetchSite } from "@/redux/features/site/thunk";
import EmbedsLayout from "@/components/shared/layouts/embeds/default";
import { setAdapter } from "@/redux/features/adapter/slice";
import type { ReactElement } from "react";
import { fetchTheme } from "@/redux/features/theme/thunk";
import { fetchHomePageRevision } from "@/redux/features/home-page-revision/thunk";

export default function Page() {
  return <App />;
}

Page.getLayout = function getLayout(page: ReactElement) {
  return <EmbedsLayout>{page}</EmbedsLayout>;
};

/**
 * Note: Can't use withCommonData HOC
 * we have a dependency on clients using bazaar.* URL,
 * and we fetch site url from projectfinder endpoint from schmaltz
 * and it isn't readily available on first SSR
 */
export const getServerSideProps: GetServerSideProps =
  wrapper.getServerSideProps(
    (store) => async (ctx: GetServerSidePropsContext) => {
      const userLoggedIn = ctx.req.cookies["unexpected_thunder"] || false;

      const config = {
        headers: {
          cookie: ctx?.req?.headers?.cookie
        }
      };
      await store.dispatch(fetchProjectFinder(ctx.query));
      const { siteUrl } = store.getState().projectFinder.queryFilter;

      store.dispatch(setAdapter({ baseUrl: siteUrl }));

      if (!userLoggedIn) {
        await store.dispatch(fetchAnonymousUser({ config }));
      }

      await store.dispatch(fetchSite({ config }));

      await store.dispatch(fetchTheme({ config }));
      await store.dispatch(fetchHomePageRevision({ config }));

      await store.dispatch(fetchProjects({ config }));

      return {
        props: {}
      };
    }
  );
